import { StudentEnrollmentList } from "./StudentEnrollmentList";
import { StudentEnrollmentCreate } from "./StudentEnrollmentCreate";
import { StudentEnrollmentEdit } from "./StudentEnrollmentEdit";

export default {
    list: StudentEnrollmentList,
    create: StudentEnrollmentCreate,
    edit: StudentEnrollmentEdit
};
